import React from "react";
import { Content } from "./Content";
import { Header } from "../Header";
import style from "./style.module.scss";
import { LabManual } from "@learningblocks/simulations/shared-components/lib/LabManual";
import notebookGrid from "./assets/notebook-grid.svg";

/**
 * Props for the NotebookManualModal component
 */
interface NotebookManualModalProps {
  isOpen: boolean;
  onClose: () => void;
  notebookCollapsed: boolean;
  size: "sm" | "md" | "lg";
  data: {
    displayPageNum?: boolean;
    displayHeading?: boolean;
    displayDate?: boolean;
    label?: string;
    showNotebookGridBody?: boolean;
    components?: Component[];
  };
}

export interface Component {
  id: string;
  type: string;
  [key: string]: string | number | boolean | object | undefined;
}

/**
 * NotebookManualModal:
 *  - Dynamic component that renders the NotebookManual
 *    its working
 */
export function NotebookManualModal(props: NotebookManualModalProps) {
  return (
    <LabManual
      isOpen={props.isOpen}
      className={style.manualModal}
      notebookExpanded={!props.notebookCollapsed}
      closeButton={true}
      onClose={props.onClose}
      alignLeft={true}
    >
      <div className={style.container}>
        <Header
          className={style.header}
          displayPageNum={props?.data?.displayPageNum || false}
          displayHeading={props?.data?.displayHeading || false}
          displayDate={props?.data?.displayDate || false}
          label={props?.data?.label || ""}
          size={props.size}
        />
        <div
          className={
            props?.data?.showNotebookGridBody
              ? `${style.grid} ${style.section}`
              : style.section
          }
          style={{
            backgroundImage: props?.data?.showNotebookGridBody
              ? `url(${notebookGrid})`
              : "none",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Content components={props?.data?.components || []} />
        </div>
      </div>
    </LabManual>
  );
}

NotebookManualModal.defaultProps = {
  isOpen: false,
  size: "lg",
};
